import { render, staticRenderFns } from "./FormList.vue?vue&type=template&id=0cc4adcf&scoped=true&"
import script from "./FormList.vue?vue&type=script&lang=ts&"
export * from "./FormList.vue?vue&type=script&lang=ts&"
import style0 from "./FormList.vue?vue&type=style&index=0&id=0cc4adcf&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc4adcf",
  null
  
)

export default component.exports